export const assessmentsApiHandler = {
  getOrganizationAssessments: {
    method: "GET",
    path: () => `org-assessments-management`
  },
  getOrganizationAssessmentsSkipper: {
    method: "GET",
    path: () => `org-assessments-management/skipped`
  },
  getOrganizationAssessmentsStatistics: {
    method: "GET",
    path: () => `org-assessments-management/statistics`,
    params: {} as {'from'?: string | number, 'to'?: string | number}
  },
  createAssessmentOptions: {
    method: "POST",
    path: (payload: { assessmentId: string | number }) => `assessment-options/${payload.assessmentId}`
  },
  createAssessment: {
    method: "POST",
    path: () => `org-assessments-management`
  },
  deleteAssessment: {
    method: "DELETE",
    path: (payload: { assessmentId: string | number }) => `org-assessments-management/${payload.assessmentId}`
  },
  updateAssessment: {
    method: "PATCH",
    path: (payload: { assessmentId: string | number }) => `org-assessments-management/${payload.assessmentId}`
  },
  updateOrganizationAssessmentsOrders: {
    method: "PATCH",
    path: () => `org-assessments-management/order`
  },
  getSingleAssessment: {
    method: "GET",
    path: (payload: { assessmentId: string | number }) => `org-assessments-management/${payload.assessmentId}`
  }
};